import { render, staticRenderFns } from "./cancellations.vue?vue&type=template&id=ce791dc8&scoped=true&lang=html&"
import script from "./cancellations.vue?vue&type=script&lang=js&"
export * from "./cancellations.vue?vue&type=script&lang=js&"
import style0 from "./cancellations.vue?vue&type=style&index=0&id=ce791dc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce791dc8",
  null
  
)

export default component.exports